import { render } from "./printaccounting.vue?vue&type=template&id=05696117&scoped=true"
import script from "./printaccounting.vue?vue&type=script&lang=js"
export * from "./printaccounting.vue?vue&type=script&lang=js"

import "./printaccounting.vue?vue&type=style&index=0&id=05696117&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05696117"]])

export default __exports__